import React from 'react';
import {useIntl} from 'react-intl';
import {useCreateLinkContext} from '../CreateLinkContext';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import InvalidEmailMessage from '../../../_common/components/InvalidEmailMessage';
import FieldRadiobutton from '../../../_common/components/FieldRadiobutton';
import {StyledFieldTextareaAutosize} from '../../../_common/components/FieldTextareaAutosize';
import {usePriceQuotesPageContext} from '../PriceQuotesPageContext';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupCreateLink = () => {
  const intl = useIntl();
  const {
    showLinkModal,
    setShowLinkModal,
    linkPriceQuoteID,
    setLinkPriceQuoteID
  } = usePriceQuotesPageContext();
  const {formik, handleCreate, uniqueEmails} = useCreateLinkContext();
  const handleCloseModal = () => setShowLinkModal(false);
  const header = [
    intl.formatMessage({
      id: 'price-quote-details-message-create-link',
      defaultMessage: 'Create a customer approval link for a proposal'
    }),
    linkPriceQuoteID,
  ].filter(Boolean).join(' ');

  const handleClose = () => {
    handleCloseModal();
    formik.resetForm();
    setLinkPriceQuoteID(null);
  };
  const handleSubmit = async () => {
    await handleCreate();
    handleCloseModal();
    formik.resetForm();
    setLinkPriceQuoteID(null);
  };

  const getRadioEmail = (email) => {
    return (
      <FieldRadiobutton
        fieldId={'email'}
        value={email}
        label={email}
        customContainerStyles={'m-1'}
        variant={'dot'}
      />
    );
  };

  return (
    <ModalContainer show={showLinkModal} onHide={handleCloseModal} size={'md'}>
      <div>
        <ModalHeader header={header}/>
        <ModalContent customClassnames={'bg-transparent'}>
          <StyledFieldInput
            fieldId={'email'}
            type={'email'}
            label={
              <div>
                      <span>{intl.formatMessage({
                        id: 'price-quote-details-label-email',
                        defaultMessage: 'Email'
                      })}</span>
                <span className={'text-danger'}>*</span>
              </div>
            }
            value={formik.values.email}
            onChange={e => formik.setFieldValue('email', e.target.value)}
            icon={'/media/common/Email_primary.svg'}
            customContainerStyles={'py-3'}
          />
          {formik.errors.invalidEmail && <InvalidEmailMessage/>}
          {uniqueEmails.length > 0 &&
            <div className={'d-flex mt-6 mb-4'}>{uniqueEmails.map(getRadioEmail)}</div>
          }
          <StyledFieldTextareaAutosize
            fieldId={'notes'}
            label={intl.formatMessage({id: 'price-quote-details-label-notes', defaultMessage: 'Notes'})}
            value={formik.values.notes}
            onChange={formik.handleChange}
            customContainerStyles={'py-3'}
          />
          <StyledFieldInput
            {...formik}
            fieldId={'password'}
            label={intl.formatMessage({id: 'price-quote-details-label-password', defaultMessage: 'Password'})}
            value={formik.values.password}
            onChange={e => formik.setFieldValue('password', e.target.value)}
            customContainerStyles={'py-3'}
            icon={'/media/common/Lock_primary.svg'}
          />
          <StyledFieldInput
            {...formik}
            fieldId={'passwordHint'}
            label={
              <div>
                    <span>{intl.formatMessage({
                      id: 'price-quote-details-label-passwordHint',
                      defaultMessage: 'Password hint'
                    })}</span>
                {formik.values.password && <span className={'text-danger'}>*</span>}
              </div>
            }
            value={formik.values.passwordHint}
            onChange={e => formik.setFieldValue('passwordHint', e.target.value)}
            customContainerStyles={'py-3'}
            icon={'/media/common/Hint_primary.svg'}
          />
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleClose}
            label={intl.formatMessage({id: 'button-close', defaultMessage: 'Close'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={handleSubmit}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'button-create', defaultMessage: 'Create'})}
            disabled={!formik.isValid}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </div>
    </ModalContainer>
  );
};

export default PopupCreateLink;
